import { useState } from "react";
import { Icon } from "./ui.jsx";

// Campo de búsqueda de lugar. Los lugares recientes solo aparecen mientras el campo tiene el foco.
export default function PlaceSearch({ id, label, value, onChange, onSubmit, busy, disabled, placeholder, recentPlaces = [], onPickRecent, onLocate, hint }) {
  const [focused, setFocused] = useState(false);
  const showRecent = focused && recentPlaces.length > 0;

  function pick(place) {
    onPickRecent(place);
    setFocused(false);
    document.getElementById(id)?.blur();
  }

  return (
    <form className={`place-search${showRecent ? " is-open" : ""}`} onSubmit={onSubmit} role="search">
      <div className="place-field">
        <Icon name="search" />
        <label className="place-label" htmlFor={id}>{label}</label>
        <input
          id={id}
          type="search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onKeyDown={(event) => { if (event.key === "Escape") { event.preventDefault(); event.currentTarget.blur(); } }}
          placeholder={placeholder}
          autoComplete="off"
          enterKeyHint="search"
        />
        {busy && <span className="spinner" aria-label="Buscando" />}
        {onLocate && (
          <button className="field-button" type="button" onClick={onLocate} aria-label="Usar mi ubicación" title="Usar mi ubicación">
            <Icon name="locate" />
          </button>
        )}
        <button className="field-button is-submit" type="submit" disabled={disabled || busy} aria-label="Buscar">
          <Icon name="search" />
        </button>
      </div>
      {hint && !showRecent && <p className="place-hint">{hint}</p>}
      {showRecent && (
        <div className="recent-menu" role="listbox" aria-label="Lugares recientes">
          <span className="recent-title">Recientes</span>
          {recentPlaces.map((place) => (
            <button
              key={`${place.lat}:${place.lng}`}
              type="button"
              role="option"
              aria-selected="false"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => pick(place)}
            >
              <Icon name="clock" />
              <span><b>{place.query || place.label}</b>{place.query && place.label !== place.query && <small>{place.label}</small>}</span>
            </button>
          ))}
        </div>
      )}
    </form>
  );
}
